import styled from 'styled-components';

export const Logo = styled.h1`
    font-family: 'Rufina', serif;
    a {
        color: #F3E8E4;
        font-weight: normal;
        text-decoration: none;
    }
`

export const Container = styled.div`
    background-color: #3C3F3B;
    width: 100%;
    padding: 20px;
`

